<template>
    <header
        class="font-semibold text-gray-800 dark:bg-gray-900 dark:text-gray-100"
        :class="!cmsView && 'fixed right-0 left-0'"
    >
        <nav class="container-footer mx-auto">
            <div class="flex items-center justify-between">
                <!-- Left side of the navigation. -->
                <div class="flex items-center">
                    <button
                        v-if="$page.props.user && !isRetailer && !isSalesperson && !isProductShowPage"
                        class="mr-2 md:mr-8 focus:outline-none md:inline-block"
                        aria-label="Open Menu"
                        @click="$emit('toggleSidebarUnified')"
                    >
                        <HamburgerIcon class="w-8 fill-current" />
                    </button>

                    <AppLogo v-if="!sidebarStatus" />
                </div>

                <!-- Right Side Of The Navbar Header -->
                <div
                    class="flex items-center justify-end space-x-4"
                    :class="!cmsView ? 'flex-grow' : ''"
                >
                    <!-- Search -->
                    <div
                        v-if="isRetailer || !$page.props.user"
                        class="relative flex-grow hidden border border-gray-300 rounded-lg md:block"
                    >
                        <!-- @click="showSearchOverlay" -->
                        <input
                            v-model="search"
                            :class="[
                                'w-full h-10 px-3 py-1 pl-10 rounded-md outline-none focus:shadow-md transition-all duration-300',
                                isDashboard
                                    ? 'bg-transparent text-white placeholder-white shadow-gray-500 backdrop-blur-lg'
                                    : 'bg-gray-50 text-gray-900 placeholder-gray-500 border border-gray-300 focus:bg-gray-100',
                            ]"
                            placeholder="Search ..."
                            @keydown.enter="getSearchResultsFor"
                        />
                        <div class="absolute top-0 flex items-center h-full ml-4">
                            <SearchIcon :class="['w-5 fill-current', isDashboard ? 'text-white' : 'text-gray-400']" />
                        </div>
                    </div>

                    <div
                        v-if="isSalesperson"
                        class="relative flex items-center"
                    >
                        <JetDropdown
                            align="left"
                            width="72"
                            :content-classes="['bg-white']"
                        >
                            <template #trigger>
                                <button
                                    class="relative flex text-sm transition duration-150 ease-in-out rounded focus:outline-none"
                                >
                                    <!-- @click="captureLocationData()" -->
                                    <ClockIcon class="w-5 fill-current md:mx-2 md:w-6" />
                                </button>
                            </template>

                            <template #content>
                                <div class="block px-4 py-2 text-xs text-gray-400">Select retailer</div>

                                <div>
                                    <div class="pt-4 pb-36">
                                        <Multiselect
                                            v-model="selectedRetailerToLog"
                                            :options="$page.props.assignedRetailers"
                                            :multiple="false"
                                            :close-on-select="true"
                                            placeholder="Pick Retailer"
                                            label="name"
                                            track-by="name"
                                        />

                                        <div
                                            v-if="selectedRetailerToLog && selectedRetailerToLog.id"
                                            class="mt-2 text-xs text-gray-500"
                                        >
                                            <span v-if="checkingStatus">Checking status…</span>
                                            <span v-else>
                                                Status:
                                                <span
                                                    v-if="hasOpenLog"
                                                    class="font-semibold text-green-700"
                                                    >Clocked In</span
                                                >
                                                <span
                                                    v-else
                                                    class="font-semibold text-gray-700"
                                                    >Not Clocked In</span
                                                >
                                            </span>
                                        </div>
                                    </div>

                                    <div class="px-4 py-4 flex gap-2">
                                        <!-- CLOCK IN -->
                                        <button
                                            type="button"
                                            class="w-1/2 py-2 font-bold text-white rounded-md"
                                            :class="
                                                clockInDisabled
                                                    ? 'bg-gray-400 cursor-not-allowed'
                                                    : 'bg-green-600 hover:bg-green-700'
                                            "
                                            :disabled="clockInDisabled"
                                            @click="clockIn"
                                        >
                                            {{ busy && !hasOpenLog ? 'Saving…' : 'Clock In' }}
                                        </button>

                                        <!-- CLOCK OUT -->
                                        <button
                                            type="button"
                                            class="w-1/2 py-2 font-bold text-white rounded-md"
                                            :class="
                                                clockOutDisabled
                                                    ? 'bg-gray-400 cursor-not-allowed'
                                                    : 'bg-red-600 hover:bg-red-700'
                                            "
                                            :disabled="clockOutDisabled"
                                            @click="clockOut"
                                        >
                                            {{ busy && hasOpenLog ? 'Saving…' : 'Clock Out' }}
                                        </button>
                                    </div>

                                    <a
                                        class="block py-2 font-bold text-center text-white bg-gray-800 rounded-b-md dark:bg-gray-700 hover:underline"
                                        :href="route('location-logs.index')"
                                    >
                                        View all logs
                                    </a>

                                    <!-- <a
                                        class="block py-2 font-bold text-center text-white bg-gray-800 rounded-b-md dark:bg-gray-700 hover:underline"
                                        @click="captureLocationData()"
                                    >
                                        Log location
                                    </a> -->
                                </div>
                            </template>
                        </JetDropdown>
                        <!-- <button
                            class="relative flex text-sm transition duration-150 ease-in-out rounded focus:outline-none"
                            @click="captureLocationData()"
                        >
                            <ClockIcon class="w-5 fill-current md:mx-2 md:w-6" />
                        </button> -->
                    </div>

                    <!-- cart -->
                    <div
                        v-if="$page.props.user && (isRetailer || isSalesperson)"
                        class="relative flex items-center"
                    >
                        <button
                            class="relative flex text-sm transition duration-150 ease-in-out rounded focus:outline-none"
                            @click="$inertia.get(route('cartItems.index'))"
                        >
                            <CartIcon class="w-5 fill-current md:mx-2 md:w-6" />
                            <div
                                v-if="$page.props.cartItems.length"
                                class="absolute px-1 text-xs text-white bg-red-400 rounded-full -right-2 -top-1"
                            >
                                {{ $page.props.cartItems.length }}
                            </div>
                        </button>
                        <!-- <JetDropdown
                            align="left"
                            width="72"
                            :content-classes="['bg-white']"
                        >
                            <template #trigger>
                                <button
                                    class="relative flex text-sm transition duration-150 ease-in-out rounded focus:outline-none"
                                >
                                    <CartIcon class="w-5 fill-current md:mx-2 md:w-6" />
                                    <div
                                        v-if="$page.props.cartItems.length"
                                        class="absolute px-1 text-xs text-white bg-red-400 rounded-full -right-2 -top-1"
                                    >
                                        {{ $page.props.cartItems.length }}
                                    </div>
                                </button>
                            </template>

                            <template #content>
                                <div class="block px-4 py-2 text-xs text-gray-400">
                                    Cart Items
                                </div>

                                <div v-if="$page.props.cartItems && $page.props.cartItems.length">
                                    <div class="pt-2">
                                        <a
                                            v-for="cartItem in $page.props.cartItems"
                                            :key="cartItem.id"
                                            class="flex items-center justify-between px-4 py-3 transition-colors duration-200 transform border-b cursor-pointer hover:bg-gray-100"
                                            @click="goto('products.show', { dummy: `${convertToKebabCase(cartItem.product.brand.name)}-${convertToKebabCase(cartItem.product.name)}`, product: cartItem.product_slug })"
                                        >
                                            <div class="flex items-center">
                                                <img
                                                    class="object-cover w-8 h-8 mx-1 rounded-full"
                                                    :src="
                                                        cartItem.product.images.length
                                                            ? cartItem.product.images[0].image_path
                                                            : defaultImage
                                                    "
                                                    alt="avatar"
                                                >
                                                <div class="mx-2 text-sm text-gray-600 dark:text-white">
                                                    {{ cartItem.product.name }}
                                                    <div class="text-blue-500">
                                                        {{ cartItem.created_at | fromNow }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div>{{ config(common.currency, cartItem.product.owner) }} {{ parseFloat(cartItem.product.price).toFixed(2) }}</div>
                                        </a>
                                    </div>

                                    <a
                                        :href="route('cartItems.index')"
                                        class="block py-2 font-bold text-center text-white bg-gray-800 rounded-b-md dark:bg-gray-700 hover:underline"
                                    >
                                        Go to cart page
                                    </a>
                                </div>

                                <div v-else>
                                    <div class="py-2">
                                        <a class="flex items-center px-4 py-3 transition-colors duration-200 transform">
                                            <div class="mx-2 text-sm text-gray-600">
                                                No items in cart.
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </JetDropdown> -->
                    </div>

                    <!-- Chat -->
                    <div
                        v-if="$page.props.user && !isAdmin"
                        class="relative flex items-center"
                    >
                        <JetDropdown
                            align="left"
                            width="72"
                            :content-classes="['bg-white']"
                        >
                            <template #trigger>
                                <button
                                    class="relative flex text-xs transition duration-150 ease-in-out rounded md:text-sm focus:outline-none"
                                >
                                    <ChatIcon class="w-5 fill-current md:mx-2 md:w-6" />
                                    <div
                                        v-if="$page.props.messages.length"
                                        class="absolute w-5 h-5 -right-2 -top-1"
                                    >
                                        <span
                                            class="absolute inline-flex w-full h-full bg-red-400 rounded-full opacity-75 animate-ping"
                                        />
                                        <span
                                            class="relative inline-flex items-center justify-center h-4 px-1 text-xs text-white bg-red-500 rounded-full"
                                        >
                                            {{ $page.props.messages.length }}
                                        </span>
                                    </div>
                                </button>
                            </template>

                            <template #content>
                                <div class="block px-4 py-2 text-xs text-gray-400">Messages</div>

                                <div v-if="$page.props.messages.length">
                                    <div class="pt-2">
                                        <a
                                            v-for="message in $page.props.messages"
                                            :key="message.id"
                                            class="flex items-center px-4 py-3 transition-colors duration-200 transform border-b cursor-pointer hover:bg-gray-100"
                                            @click="gotoMessages(message)"
                                        >
                                            <img
                                                class="object-cover w-8 h-8 mx-1 rounded-full"
                                                :src="message.sender.profile_photo_url"
                                                alt="avatar"
                                            />
                                            <div
                                                class="mx-2 text-sm text-gray-600 dark:text-white"
                                                :class="message.read_at ? '' : 'font-black'"
                                            >
                                                {{ message.message }}
                                                <div
                                                    class="text-blue-500"
                                                    :class="message.read_at ? '' : 'font-bold'"
                                                >
                                                    {{ message.created_at | fromNow }}
                                                </div>
                                            </div>
                                        </a>
                                    </div>

                                    <a
                                        :href="route('chat.index')"
                                        class="block py-2 font-bold text-center text-white bg-gray-800 rounded-b-md dark:bg-gray-700 hover:underline"
                                    >
                                        See all messages
                                    </a>
                                </div>

                                <div v-else>
                                    <div class="py-2">
                                        <a class="flex items-center px-4 py-3 transition-colors duration-200 transform">
                                            <div class="mx-2 text-sm text-gray-600">No unread message.</div>
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </JetDropdown>
                    </div>

                    <!-- Notification -->
                    <div
                        v-if="$page.props.user"
                        class="relative flex items-center"
                    >
                        <JetDropdown
                            align="left"
                            width="72"
                            :content-classes="['bg-white']"
                        >
                            <template #trigger>
                                <button
                                    class="relative flex text-sm transition duration-150 ease-in-out rounded focus:outline-none"
                                >
                                    <BellIcon class="w-5 fill-current md:mx-2 md:w-6" />
                                    <div
                                        v-if="$page.props.notifications.length"
                                        class="absolute w-5 h-5 -right-2 -top-1"
                                    >
                                        <span
                                            class="absolute inline-flex w-full h-full bg-red-400 rounded-full opacity-75 animate-ping"
                                        />
                                        <span
                                            class="relative inline-flex items-center justify-center h-4 px-1 text-xs text-white bg-red-500 rounded-full"
                                        >
                                            {{ $page.props.notifications.length }}
                                        </span>
                                    </div>
                                </button>
                            </template>

                            <template #content>
                                <div class="block px-4 py-2 text-xs text-gray-400">Notifications</div>

                                <div v-if="$page.props.notifications.length">
                                    <div class="pt-2">
                                        <a
                                            v-for="notification in $page.props.notifications"
                                            :key="notification.id"
                                            class="flex items-center px-4 py-3 transition-colors duration-200 transform border-b cursor-pointer hover:bg-gray-100"
                                            @click="markAsRead(notification)"
                                        >
                                            <img
                                                class="object-cover w-8 h-8 mx-1 rounded-full"
                                                :src="notification.data.profilePhotoUrl"
                                                alt="avatar"
                                            />
                                            <div
                                                class="mx-2 text-sm text-gray-600 dark:text-white"
                                                :class="notification.read_at ? '' : 'font-black'"
                                            >
                                                {{ notification.data.message }}
                                                <div
                                                    class="text-blue-500"
                                                    :class="notification.read_at ? '' : 'font-bold'"
                                                >
                                                    {{ notification.created_at | fromNow }}
                                                </div>
                                            </div>
                                        </a>
                                    </div>

                                    <a
                                        :href="route('notifications.index')"
                                        class="block py-2 font-bold text-center text-white bg-gray-800 rounded-b-md dark:bg-gray-700 hover:underline"
                                    >
                                        See all notifications
                                    </a>
                                </div>

                                <div v-else>
                                    <div class="py-2">
                                        <a class="flex items-center px-4 py-3 transition-colors duration-200 transform">
                                            <div class="mx-2 text-sm text-gray-600">No notifications available</div>
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </JetDropdown>
                    </div>

                    <!-- Light and Dark Mode Toggle -->
                    <!-- <button
                        @click="toggleDarkMode"
                        class="ml-auto px-4 py-1"
                    >
                        {{ isDark ? '🌙' : '☀️' }}
                    </button> -->

                    <!-- Settings Dropdown -->
                    <div
                        v-if="$page.props.user"
                        class="relative flex items-center max-h-9"
                    >
                        <div class="mr-3 text-xs text-right md:text-sm">
                            <div>{{ greetings }}</div>
                            <div>{{ $page.props.user.name }}</div>
                        </div>
                        <JetDropdown
                            align="right"
                            width="48"
                        >
                            <template #trigger>
                                <button
                                    v-if="$page.props.jetstream.managesProfilePhotos"
                                    class="flex w-8 h-8 text-sm transition duration-150 ease-in-out rounded-full md:w-10 md:h-10 focus:outline-none focus:ring-4 focus:ring-gray-300"
                                >
                                    <img
                                        class="object-cover w-full h-full rounded-full"
                                        :src="$page.props.user.profile_photo_url"
                                        :alt="$page.props.user.name"
                                    />
                                </button>

                                <span
                                    v-else
                                    class="inline-flex rounded-md"
                                >
                                    <button
                                        type="button"
                                        class="inline-flex items-center px-3 py-2 text-sm font-medium leading-4 text-gray-500 transition duration-150 ease-in-out bg-white border border-transparent rounded-md hover:text-gray-700 focus:outline-none"
                                    >
                                        {{ $page.props.user.name }}

                                        <svg
                                            class="ml-2 -mr-0.5 h-4 w-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                </span>
                            </template>

                            <template #content>
                                <!-- Account Management -->
                                <div class="block px-4 py-2 text-xs text-gray-400">Manage Account</div>

                                <JetDropdownLink :href="route('profile.show')"> Profile </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="isRetailer"
                                    :href="route('reports.retailer.orders', $page.props.user)"
                                >
                                    My Invoices
                                </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="isRetailer"
                                    :href="route('retailer.statement')"
                                >
                                    My Statement
                                </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="!isAdmin && !isSalesperson"
                                    :href="
                                        isKycSubmitted
                                            ? route('kyc.show', { kycId: $page.props.user.kyc_id })
                                            : route('kyc.create')
                                    "
                                >
                                    <div class="flex items-center justify-between">
                                        <div>KYC</div>

                                        <ErrorIcon
                                            v-if="isKycSubmitted && !$page.props.user.kyc"
                                            class="w-6 h-6 text-yellow-400 fill-current"
                                        />
                                    </div>
                                </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="!isSalesperson"
                                    :href="route('creditRequest.index')"
                                >
                                    Credit Request List
                                </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="isRetailer"
                                    :href="route('creditRequest.create')"
                                >
                                    Credit Request
                                </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="!isSalesperson"
                                    :href="route('complains.index')"
                                >
                                    Complain List
                                </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="!isAdmin && !isSalesperson"
                                    :href="route('complains.create')"
                                >
                                    Complain to Seller
                                </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="isRetailer"
                                    :href="route('chat.index')"
                                >
                                    Contact Seller
                                </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="isRetailer"
                                    :href="route('account.index')"
                                >
                                    My Orders
                                </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="isAdmin"
                                    :href="route('commons.index')"
                                >
                                    Application Configs
                                </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="isAdmin"
                                    :href="route('kyc.index')"
                                >
                                    KYC List
                                </JetDropdownLink>

                                <!-- <JetDropdownLink
                                    v-if="$page.props.jetstream.hasApiFeatures"
                                    :href="route('api-tokens.index')"
                                >
                                    API Tokens
                                </JetDropdownLink> -->

                                <JetDropdownLink
                                    v-if="isSalesperson"
                                    :href="route('reports.invoice')"
                                >
                                    Invoice Report
                                </JetDropdownLink>

                                <JetDropdownLink
                                    v-if="isSalesperson"
                                    :href="route('reports.retailer')"
                                >
                                    Retailer Report
                                </JetDropdownLink>

                                <div class="border-t border-gray-100" />

                                <!-- Authentication -->
                                <form @submit.prevent="handleLogout">
                                    <JetDropdownLink as="button"> Logout </JetDropdownLink>
                                </form>
                            </template>
                        </JetDropdown>
                    </div>

                    <div
                        v-else
                        class="flex items-center space-x-4 text-sm md:text-md"
                    >
                        <div
                            class="px-2 uppercase cursor-pointer md:px-2"
                            @click="$inertia.get(route('aboutus'))"
                        >
                            About
                        </div>

                        <!-- Commented to remove the app store logo in navbar -->
                        <!-- <inertia-link
                            :href="route('appstore')"
                            class="hidden px-2 py-1 uppercase duration-100 ease-linear transform cursor-pointer md:block md:px-1 md:py-2 hover:bg-green-50"
                        >
                            <img
                                class="object-cover h-8 w-28"
                                :src="mblAppUrl"
                                alt="app store"
                            />
                        </inertia-link> -->

                        <inertia-link
                            :href="route('login')"
                            :class="[
                                isDashboard ? 'text-gray-500' : '',
                                'px-2 py-1 uppercase duration-100 ease-linear transform bg-gray-50 bg-opacity-50 border border-gray-200 rounded-lg cursor-pointer md:px-4 md:px-5 md:py-2 hover:bg-gray-800 hover:border-gray-800 hover:text-white',
                            ]"
                        >
                            Login
                        </inertia-link>
                    </div>
                </div>
            </div>

            <!-- Search bar for small screen  -->
            <div
                v-if="isRetailer || !$page.props.user"
                class="relative flex items-center flex-grow pt-4 md:hidden"
            >
                <!-- @click="showSearchOverlay" -->
                <input
                    v-model="search"
                    class="w-full h-10 px-3 py-2 pl-8 text-sm border border-gray-300 rounded-lg bg-gray-50 focus:bg-gray-100 focus:outline-none focus:shadow-outline"
                    placeholder="Search..."
                    @keydown.enter="getSearchResultsFor"
                />
                <div class="absolute flex items-center h-full ml-2">
                    <SearchIcon class="w-4 text-gray-400 fill-current" />
                </div>
                <!-- <div
                    class="absolute flex items-center justify-center w-8 h-full top-1 right-5"
                    @click="getSearchResultsFor"
                >
                    &#x23CE;
                </div> -->
            </div>
        </nav>
    </header>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import JetDropdown from '../Jetstream/Dropdown.vue';
    import JetDropdownLink from '../Jetstream/DropdownLink.vue';
    import CartIcon from '../Components/Icons/CartIcon.vue';
    import ClockIcon from '../Components/Icons/ClockIcon.vue';
    import SearchIcon from '../Components/Icons/SearchIcon.vue';
    import BellIcon from '../Components/Icons/BellIcon.vue';
    import ChatIcon from '../Components/Icons/ChatIcon.vue';
    import HamburgerIcon from '../Components/Icons/HamburgerIcon.vue';
    import ErrorIcon from '../Components/Icons/ErrorIcon.vue';
    import AppLogo from '../Components/AppLogo.vue';
    import common from '../common';

    export default {
        components: {
            JetDropdown,
            JetDropdownLink,
            CartIcon,
            ClockIcon,
            SearchIcon,
            BellIcon,
            HamburgerIcon,
            ChatIcon,
            AppLogo,
            ErrorIcon,
            Multiselect,
        },

        props: {
            sidebarStatus: {
                type: Boolean,
                required: true,
            },
        },

        data() {
            return {
                common,
                search: null,
                isOpen: false,
                isDark: false,
                selectedRetailerToLog: null,

                hasOpenLog: false,
                openLogId: null,
                checkingStatus: false,
                busy: false,
            };
        },

        computed: {
            greetings() {
                const d = new Date();
                const time = d.getHours();
                let greeting = '';

                if (time < 12) {
                    greeting = 'Good morning!';
                }
                if (time >= 12) {
                    greeting = 'Good afternoon!';
                }
                if (time > 16) {
                    greeting = 'Good evening!';
                }
                return greeting;
            },

            defaultImage() {
                return `${process.env.MIX_SENTRY_DSN_PUBLIC}/storage/default/default.png`;
            },

            // todo: might want to replace this function logic with a regex
            isProductShowPage() {
                return this.$page.url.includes('/products/');
            },

            mblAppUrl() {
                return `${process.env.MIX_SENTRY_DSN_PUBLIC}/storage/default/app_store.png`;
            },

            clockInDisabled() {
                return (
                    !this.selectedRetailerToLog ||
                    !this.selectedRetailerToLog.id ||
                    this.checkingStatus ||
                    this.busy ||
                    this.hasOpenLog
                );
            },
            clockOutDisabled() {
                return (
                    !this.selectedRetailerToLog ||
                    !this.selectedRetailerToLog.id ||
                    this.checkingStatus ||
                    this.busy ||
                    !this.hasOpenLog
                );
            },
        },

        watch: {
            isOpen: {
                handler() {
                    this.$emit('toggleLeftSidebar');
                },
            },

            selectedRetailerToLog: {
                handler(val) {
                    this.hasOpenLog = false;
                    this.openLogId = null;
                    if (val && val.id) {
                        this.fetchLocationLogStatus(val.id);
                    }
                },
                deep: false,
            },
        },

        mounted() {
            this.isDark = localStorage.theme === 'dark';
            this.applyTheme();
            document.addEventListener('keydown', (e) => {
                if (e.keyCode === '27' && this.isOpen) this.isOpen = false;
            });
        },

        methods: {
            toggleDarkMode() {
                this.isDark = !this.isDark;
                localStorage.theme = this.isDark ? 'dark' : 'light';
                this.applyTheme();

                // if (
                //     localStorage.theme === 'dark' ||
                //     (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
                // ) {
                //     this.isDark = true;
                // } else {
                //     this.isDark = false;
                // }
                // this.applyTheme();
            },
            applyTheme() {
                const html = document.documentElement;
                if (this.isDark) {
                    html.classList.add('dark');
                } else {
                    html.classList.remove('dark');
                }
            },
            captureLocationData() {
                if (this.selectedRetailerToLog == null) {
                    console.log('Need to select retailer first');
                } else if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            this.$inertia.post(route('log.location'), {
                                longitude: position.coords.longitude,
                                latitude: position.coords.latitude,
                                time: this.moment().format('hh:mm'),
                                retailerId: this.selectedRetailerToLog.id,
                            });
                        },
                        (error) => console.log(error.message),
                    );
                } else {
                    console.log('geolocation not supported');
                }
            },

            getBrowserLocation() {
                return new Promise((resolve, reject) => {
                    if (!navigator.geolocation) return reject(new Error('Geolocation not supported'));
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            resolve({
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude,
                            });
                        },
                        (error) => reject(error),
                        { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 },
                    );
                });
            },

            fetchLocationLogStatus(retailerId) {
                this.checkingStatus = true;

                // NOTE: this uses plain fetch; you can also use this.$axios if you prefer
                fetch(route('location-logs.status', { retailer_id: retailerId }), {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                    credentials: 'same-origin',
                })
                    .then((res) => {
                        if (!res.ok) throw new Error('Failed to load status');
                        return res.json();
                    })
                    .then((data) => {
                        this.hasOpenLog = !!data.has_open_log;
                        this.openLogId = data.open_log_id || null;
                    })
                    .catch((e) => {
                        console.error(e);
                        this.hasOpenLog = false;
                        this.openLogId = null;
                    })
                    .finally(() => {
                        this.checkingStatus = false;
                    });
            },

            clockIn() {
                if (this.clockInDisabled) return;

                this.busy = true;

                this.getBrowserLocation()
                    .then((loc) => {
                        this.$inertia.post(
                            route('location-logs.clock-in'),
                            {
                                retailer_id: this.selectedRetailerToLog.id,
                                latitude: String(loc.latitude),
                                longitude: String(loc.longitude),
                            },
                            {
                                preserveScroll: true,
                                onFinish: () => {
                                    this.fetchLocationLogStatus(this.selectedRetailerToLog.id);
                                    this.busy = false;
                                },
                            },
                        );
                    })
                    .catch((e) => {
                        this.busy = false;
                        alert(e.message || 'Unable to capture location. Please allow location permission.');
                    });
            },

            clockOut() {
                if (this.clockOutDisabled) return;

                this.busy = true;

                this.getBrowserLocation()
                    .then((loc) => {
                        this.$inertia.post(
                            route('location-logs.clock-out'),
                            {
                                retailer_id: this.selectedRetailerToLog.id,
                                latitude: String(loc.latitude),
                                longitude: String(loc.longitude),
                            },
                            {
                                preserveScroll: true,
                                onFinish: () => {
                                    this.fetchLocationLogStatus(this.selectedRetailerToLog.id);
                                    this.busy = false;
                                },
                            },
                        );
                    })
                    .catch((e) => {
                        this.busy = false;
                        alert(e.message || 'Unable to capture location. Please allow location permission.');
                    });
            },

            showSearchOverlay() {
                this.$emit('toggleSearchOverlay');
            },

            markAsRead(notification) {
                this.$axios.delete(route('notifications.delete', notification.id)).then(() => {
                    this.$inertia.get(notification.data.link);
                });
            },

            gotoMessages(message) {
                this.$inertia.get(route('chat.show', { recipientId: message.sender.id }));
            },

            getSearchResultsFor() {
                this.$inertia.get(route('search.show', this.search));
            },

            handleLogout() {
                this.$dialog
                    .confirm({
                        title: 'Confirm',
                        text: 'Are you sure you want to Logout?',
                    })
                    .then((result) => {
                        if (result.isOk) {
                            this.logout();
                        }
                    });
            },
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
